import axiosJava from "@/api/config_java";
//账号管理--列表
export const accountList = param => axiosJava.get(`/am/api/accountInfo/list`, { params: param });

export const accountInfoNumber = param => axiosJava.get(`/am/api/accountInfo/numerate`, { params: param });

//账号管理--批量操作
export const batchAdd = param => axiosJava.post(`/am/api/batch/add`, param);
//账号管理--批量操作--update
export const batchUpdate = param => axiosJava.post(`/am/api/batch/update`, param);
//开户申请
export const openAccountApply = param => axiosJava.post(`/am/api/open/application`, param);

export const queryServiceRatio = param => axiosJava.get(`/am/api/clientCompany/queryServiceRatio?platform=12`);
//验证黑名单
export const isBlackList = accountCompanyName => axiosJava.get(`/am/api/accountCompany/selectBlacklistByName?accountCompanyName=${accountCompanyName}`);

//验证用户是否可以提交充值申请
export const isCanReCharge = () => axiosJava.get(`/am/api/accountFunds/rechargeVerifica`, {});

//开户公司下拉框
export const accountCompany = param => axiosJava.get(`/am/api/accountCompany/select?name=${param.accountCompanyName}&type=${param.type}&pageNum=${param.pageNum}`);

//账号分组下拉框
export const accountGroup = () => axiosJava.get(`/am/api/accountGroup/list`);
//账号分组删除
export const deleteAccountGroup = param => axiosJava.get(`/am/api/accountGroup/delete?id=${param.id}`);
//账号分组新建和编辑
export const accountGroupSave = param => axiosJava.post(`/am/api/accountGroup/add`, param);

// 广告账户详情
export const accountInfo = param => axiosJava.get(`/am/api/accountInfo/detail?accountId=` + param.accountId);

// 可用余额
export const getClientBalance = () => axiosJava.get(`/am/api/clientCompany/getClientBalance`);

// 充值
export const rechargAdd = param => axiosJava.post(`/am/api/accountFunds/addRecharge`, param);

//BM列表
export const getBmlist = param => axiosJava.get(`/am/api/accountInfo/bmList?accountId=${param.accountId}&pageNum=${param.pageNum}&pageSize=${param.pageSize}`);

// pixel列表
export const getPixellist = param => axiosJava.get(`/am/api/accountInfo/bmPixel?accountId=${param.accountId}&pageNum=${param.pageNum}&pageSize=${param.pageSize}`);

// 导出
export const exportAccountList = param => axiosJava.post(`/am/api/accountInfo/export`, param);

//开户公司下拉框（有FB平台账户的）
export const accountCompanyFB = () => axiosJava.get(`/am/api/accountCompany/selectByPlatform`);

//上传--此处忘了传参导致跨域！！！！！！！！
export const upload = param => axiosJava.post(`/am/api/open/upload`, param);

//获取客户类别
export const getTWClientType = () => axiosJava.get(`/am/api/open/getTWClientType`);

//获取投放国家
export const getCountry = () => axiosJava.get(`/am/api/open/getCountry`);

//获取投放时区
export const getZone = () => axiosJava.get(`/am/api/open/getTimeZone`);
export const getGoogleZone = () => axiosJava.get(`/am/api/open/getGoogleTimeZone`);

//获取开户公司下的账户
export const getAccounts = id => axiosJava.get(`/am/api/accountInfo/select?accountCompanyId=${id}`);

//拨入账户下拉框
export const getSelectInAccount = param => axiosJava.get(`/am/api/accountInfo/selectInAccount`, { params: param });

//最大拨款金额
export const getMaxfundingBalance = outAccountId => axiosJava.get(`/am/api/appropriation/maxAmount?outAccountId=${outAccountId}`);
// 转出账户余额
export const getMaxAmount = outAccountId => axiosJava.get(`/am/api/accountOperate/maxAmount?outAccountId=${outAccountId}`);
export const getGoogleBalances = outAccountId => axiosJava.get(`/am/api/accountFunds/googleOutAccount?outAccountId=${outAccountId}`);

//授信拨款
export const creditAllocate = param => axiosJava.post(`/am/api/appropriation/add?${param}`);

//开户申请列表
export const getOpenList = param => axiosJava.get(`/am/api/open/list?${param}`);

//开户申请详情
export const getOpenDetail = id => axiosJava.get(`/am/api/open/details?id=${id}`);

//授信充值申请
export const creaditRecharge = param => axiosJava.post(`/am/api/accountInfo/recharge`, param);

//清零申请
export const clearApply = param => axiosJava.post(`/am/api/accountInfo/apply`, param);

export const userOperate = param => axiosJava.post(`/am/api/accountOperate/addBMOperate`, JSON.parse(param));

//新增绑定、解绑Pixel
export const addPixelOperate = param => axiosJava.post(`/am/api/accountOperate/addPixelOperate`, JSON.parse(param));

//新增绑定、解绑BM
export const addBMOperate = param => axiosJava.post(`/am/api/accountOperate/addBMOperate`, JSON.parse(param));

// 账户改名
export const addUpdateName = param => axiosJava.post(`/am/api/accountOperate/addUpdateName`, JSON.parse(param));

// 分组保存
export const submitGroup = param => axiosJava.post(`/am/api/accountGroup/addRelation`, JSON.parse(param));

//OE申请列表
export const OEApplyList = param => axiosJava.get(`/am/api/open/oeList`, { params: param });

//Facebook OE查询详情
export const OEApplyDetail = id => axiosJava.get(`/am/api/open/oeDetail?requisitionId=${id}`);

//OE申请提交
export const OEApplySub = param => axiosJava.post(`/am/api/open/oeSubmit`, param);

//申请开户获取审批记录
export const getHistory = param => axiosJava.get(`/am/api/open/examineRecord`, { params: param });

//最大开户数
export const getMaxOpen = param => axiosJava.get(`/am/api/open/maxAccountOpenNum`, { params: param });

//批量操作申请列表
export const getBatchList = param => axiosJava.get(`/am/api/batch/list`, { params: param });

//批量操作导入
export const batchDataImport = param => axiosJava.post(`/am/api/batch/dataImport`, param);

//批量操作申请列表--详情列表
export const getBatchDetail = id => axiosJava.get(`/am/api/batch/details?id=${id}`);

//开户申请导入
export const openImport = param => axiosJava.post(`/am/api/open/import`, param);

//获取行业子行业
export const getIndustry = () => axiosJava.get(`/am/api/open/selectIndustry`);

//账户减款
export const addReduceLimit = param => axiosJava.post(`/am/api/accountFunds/addReduceLimit`, param);

//账户拨款
export const addAppropriation = param => axiosJava.post(`/am/api/accountFunds/addAppropriation`, param);

//账户清零
export const addClear = param => axiosJava.post(`/am/api/accountFunds/addClear`, param);

// Facebook 封户账户列表
export const getAccountPolicy = param => axiosJava.get(`/am/api/accountPolicy/list`, { params: param });

export const getAccountSameGroup = param => axiosJava.get(`/am/api/accountPolicy/getSameGroup`, { params: param });

// Facebook 拒登广告列表
export const getAdsRadList = param => axiosJava.get(`/am/api/accountPolicy/adsRadList`, { params: param });

// Facebook 整改建议列表
export const getTbrList = param => axiosJava.get(`/am/api/accountPolicy/tbrList`, { params: param });

// Facebook 整改建议详情
export const getTbrDetails = param => axiosJava.get(`/am/api/accountPolicy/tbrDetails`, { params: param });

// 获取充值服务费
export const getRechargeServiceCharge = param => axiosJava.post(`/am/api/accountFunds/getRechargeServiceCharge`, param);

// 获取减款服务费
export const getReduceLServiceCharge = param => axiosJava.post(`/am/api/accountFunds/getReduceLServiceCharge`, param);

// 获取清零服务费
export const getClearServiceCharge = param => axiosJava.post(`/am/api/accountFunds/getClearServiceCharge`, param);

// 服务费扣款规则
export const getServiceChargeRule = param => axiosJava.post(`/am/api/accountFunds/getServiceChargeRule`, param);

//获取客户类别
export const getAritReport = param => axiosJava.get(`/am/api/open/getAritReport`, { params: param });

/**
 * 绑定、解绑BC
 * @param {{accountId:string; operateType:'22'|'23'; operateContent:string}[]} params
 * @returns {Promise<{code:number;data:any;msg:string}>}
 */
export const addBCOperate = (params)=>{
  return axiosJava.post('/am/api/accountOperate/addBCOperate',params)
}